"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

import { sanitizarNext } from "@/core/seguranca";
import { BotaoGoogle } from "../_components/BotaoGoogle";

// CONTA NOVA = SÓ PELO GOOGLE (decisão Lucas 04/08).
// O cadastro por e-mail/senha depende do e-mail de confirmação, e hoje ele NÃO é
// entregue: o projeto usa o provedor de e-mail padrão do Supabase, que só entrega
// para membros do time e limita a 2 e-mails/hora. Deixar o formulário no ar só
// produzia gente parada na tela "confira seu e-mail", com um e-mail que nunca chega.
// O Google já confirma a identidade, então não há e-mail no caminho.
//
// Para reativar o formulário depois (quando houver SMTP próprio configurado):
// o fluxo continua existindo no Supabase — basta restaurar este formulário
// (supabase.auth.signUp com emailRedirectTo p/ /auth/confirm). Ver o histórico
// deste arquivo. O login por e-mail/senha em /entrar segue funcionando para quem
// já tem conta.
function FormRegistrar() {
  const next = sanitizarNext(useSearchParams().get("next")); // p/ voltar ao convite depois

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-center font-[family-name:var(--font-barlow-titulos)] text-xl font-bold uppercase tracking-wider">
        Criar conta
      </h1>
      <p className="text-center text-sm text-[#8a8a8a]">
        Use sua conta Google para criar seu acesso. É mais rápido e você não precisa
        guardar mais uma senha.
      </p>

      <BotaoGoogle next={next} rotulo="Criar conta com Google" />

      <p className="mt-2 text-center text-sm text-[#8a8a8a]">
        Já tem conta?{" "}
        <Link
          href={`/entrar?next=${encodeURIComponent(next)}`}
          className="font-medium text-[#ededed] underline underline-offset-4"
        >
          Entrar
        </Link>
      </p>
    </div>
  );
}

export default function PaginaRegistrar() {
  return (
    <Suspense>
      <FormRegistrar />
    </Suspense>
  );
}
